<p-dialog
  [contentStyle]="{ overflow: 'auto', 'max-height': '60vh', 'min-height': '50vh' }"
  [styleClass]="'sm:col-12 md:col-10 lg:col-10 xl:col-10'"
  [dismissableMask]="false"
  modal="true"
  [(visible)]="visible"
  [closable]="true"
  (onHide)="close()"
  >
  <ng-template pTemplate="header">
    <span class="p-dialog-title">
      {{'Create_DocBsk' | translate}} {{ bsk.bskLabel }}
    </span>
  </ng-template>

  @if (isLoading === false) {
    <div class="grid col-12">
      <div class="col-6">
        <p-dropdown
          autoWidth="false"
          [style]="{ width: '100%' }"
          [options]="categoryOptions"
          optionLabel="name"
          placeholder="{{'Sel_Categ' | translate}}"
          [(ngModel)]="category"
          (onChange)="onChangeCateg($event)"
        ></p-dropdown>
      </div>
      <div class="col-6">
        <p-dropdown
          autoWidth="false"
          [style]="{ width: '100%' }"
          [options]="modeleList"
          optionLabel="name"
          placeholder="{{'Sel_Model' | translate}}"
          [(ngModel)]="model"
          (onChange)="onChangeModele($event)"
        ></p-dropdown>
      </div>
      <div class="col-12 md:col-4 lg:col-4 xl:col-4">
        <span>{{'Doc_ViewPage' | translate}}</span>
        @if (showPdf && isDesktop === true) {
          <div class="full-100">
            <pdf-preview [pathPdf]="pathPdf" style="position: relative; margin-top: 5px;"></pdf-preview>
          </div>
        }
        @if (showThumbImg === true) {
          <img class="full-100"
            [src]="pathImg | safe"
            />
        }
      </div>
      <field-tools class="col-12 md:col-8 lg:col-8 xl:col-8" [dataTitle]="'Bsk_Infos' | translate">
        <dm-fieldset-header [backGround]="false"> </dm-fieldset-header>
        @if (bsk.bskType === 'btMail') {
          <div class="col-12">
            <infosmail [visuMode]="false" [bskTypeMail]="true" [editMode]="true" [infosMailDisplay]="currentInfosMail"></infosmail>
          </div>
        }
        <div class="col-12 scroll-table">
          <inputvalue
            [visuMode]="false"
            [title]="'Index_B' | translate"
            [dataVariableList]="bskVariableList"
            [libAction]="false"
            [editorService]="editorService"
            >
          </inputvalue>
        </div>
      </field-tools>
    </div>
  }
  <ng-template pTemplate="footer">
    <button class="margin" pButton type="button" (click)="onClickPreview()" label="{{'Gen_Doc' | translate}}"></button>
    <button class="margin" pButton type="button"  [disabled]="!showPdf" (click)="onClickSend()" label="{{'Add_Doc_' | translate}}"></button>
  </ng-template>
</p-dialog>
